import { fetchMeWithFavorites } from '../../actions/me';
import connectAsync from '../../utils/connectAsync';
import FavoritesRoute from './FavoritesRoute';

export default connectAsync([fetchMeWithFavorites])(FavoritesRoute);
